import React from "react";
import Button from "../../components/Button";
import SimpleModal from "./SimpleModal";
import { Title, SubTitle, SubLabel } from "./styles";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  handleNextModal: () => void;
}

const AppsModal: React.FC<Props> = ({ isOpen, toggle, handleNextModal }) => {
  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={toggle}
      title=""
      size="md"
    >
      <div style={{ padding: "24px" }} className="modal-content-responsive">
        <Title>Habilitar autenticación de dos factores</Title>
        <SubTitle>Selecciona tu aplicación de autenticación</SubTitle>

        <SubLabel style={{ marginTop: "16px" }}>
          Necesitas una aplicación de autenticación en tu teléfono para
          continuar. Recomendamos algunas de las siguientes:
        </SubLabel>

        <ul style={{ paddingLeft: "20px", marginBottom: "24px" }}>
          <li>Google Authenticator</li>
          <li>Microsoft Authenticator</li>
          <li>Authy</li>
          <li>1Password</li>
        </ul>

        <SubLabel>
          Una vez que tengas instalada tu aplicación de autenticación, haz clic
          en "Continuar" para seguir con la configuración.
        </SubLabel>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "12px",
          padding: "0 24px 24px",
        }}
        className="modal-footer-responsive"
      >
        <Button
          type="button"
          options={{ skin: "secondary", size: "md", type: "filled" }}
          onClick={toggle}
        >
          Cancelar
        </Button>
        <Button
          type="button"
          options={{ skin: "primary", size: "md", type: "filled" }}
          onClick={handleNextModal}
        >
          Continuar
        </Button>
      </div>
      
      <style>{`
        @media (max-width: 768px) {
          .modal-content-responsive {
            padding: 16px !important;
          }
          .modal-footer-responsive {
            flex-direction: column !important;
            padding: 0 16px 16px !important;
          }
          .modal-footer-responsive button {
            width: 100%;
          }
        }
      `}</style>
    </SimpleModal>
  );
};

export default AppsModal;
